export default "__VITE_ASSET__da13ed3e__"